/**
* @Description: VIP_V2_INDEX
* @author XuZiYu
* @date 2021/12/07 19:00:19
*/
<template>
    <div class="wrapper-index">
        <component ref="component" :is="componentName" :vipData="vipData" :userInfo="userInfo" :carType="carType" :cityCode="cityCode" @refresh="getVipData"></component>
    </div>
</template>

<script>
import open from './open'
import opened from './opened'
import { Toast } from 'vant'

export default {
    name: 'vipV3',
    data () {
        return {
            // 组件名称
            componentName: '',
            // vip数据
            vipData: {},
            // 版本号
            version: '',
            // 城市code
            cityCode: '',
            // 用户数据
            userInfo: {},
            // 车型默认小车
            carType: '1'
        }
    },
    watch: {
        // 初始化滚动条
        flag () {
            document.body.scrollTop = 0
        }
    },
    components: {
        opened: opened,
        open: open
    },
    methods: {
        // 获取vip数据
        getVipData () {
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            return this.$api.getVipMatchEntryV3({
                version: this.version,
                cityCode: this.cityCode,
                appType: this.appType
            }).then(res => {
                this.$nextTick(() => {
                    window.scrollTo(0, 0)
                    window.scrollTo(0, 1)
                })
                Toast.clear()
                if (res.status) {
                    this.vipData = res.result
                    this.componentName = this.vipData.vipFlag ? 'opened' : 'open'

                    // 兼容安卓关闭vip题库页面
                    if (this.$route.query.autoFinish && this.vipData.vipFlag) {
                        this.$jsBridge.callBackHandler('returnLastPage')
                    }
                } else {
                    Toast.fail(res.message)
                }
            })
        },
        // 刷新数据
        async refreshCallBack () {
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 重新获取app token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')

            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }

            // 设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 设置城市code
            this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

            // 刷新vip数据
            this.getVipData()

            // 刷新车型检查
            this.$nextTick(() => {
                this.$refs.component.checkCarType()
            })
        },
        // 初始化
        init () {
            // 获取用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 设置版本号
            this.version = this.$jsBridge.callBackHandler('getAppVersion') || ''

            // 设置城市code
            this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

            // 设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 暴露刷新页面方法
            this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)
        }
    },
    created () {
        this.init()

        this.getVipData()
    }
}
</script>

<style scoped>

</style>
